/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
import { PriceHandler } from '../../../redux/helper/CamelCase'

export default function AdorCashSection({OrderData,adorKey}) {
    return (
        <div>
            <>{Number(OrderData?.order?.summary[adorKey])> 0 &&  Number(OrderData.order.status) >= 3?
                <><div className="w-full flex justify-between items-center rounded-lg p-2 mt-3" style={{ border: '1px dashed #206C00' }}>
                    <p className="font-normal text-xs text-[#555259]">Ador Cash Eligible for this order*</p>
                    <p className="text-base font-semibold text-black">{PriceHandler(Number(OrderData?.order?.summary[adorKey]))}</p>
                </div><p className="font-bold text-[#FF3B30] text-xs13 mt-2 text-center">*Pay the Gross amount within the Due Date to avail Ador Cash.</p></>
                :null   }
         
            </>
        </div>
    )
}
